import { post, get, del } from '../request'

/**
 * 认证相关API
 */

/**
 * 用户登录
 * @param {Object} data - 登录数据
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 * @returns {Promise} 返回登录结果
 */
export function login(data) {
  return post('/ums/auth/token', data, {
    showLoading: true,
    showSuccessMessage: false, // 登录成功消息由页面自己处理
    loadingText: '登录中...'
  })
}

/**
 * 获取图形验证码
 * @returns {Promise} 返回验证码信息
 */
export function getCaptcha() {
  return get('/ums/auth/captcha', {}, {
    showLoading: false,
    showSuccessMessage: false
  })
}

/**
 * 用户退出登录
 * @returns {Promise} 返回退出结果
 */
export function logout() {
  return del('/ums/auth/token', {}, {
    showLoading: false,
    showSuccessMessage: false // 成功消息由页面处理
  })
}

/**
 * 获取当前登录管理员信息
 * @returns {Promise} 返回用户信息
 */
export function getCurrentAdmin() {
  return get('/ums/admin/current', {}, {
    showLoading: false,
    showSuccessMessage: false // 获取用户信息不需要显示成功消息
  })
}

/**
 * 刷新token（如果后端支持）
 * @returns {Promise} 返回新的token信息
 */
export function refreshToken() {
  return post('/ums/auth/refresh', {}, {
    showLoading: false,
    showSuccessMessage: false
  })
}

/**
 * 验证token是否有效
 * @returns {Promise} 返回验证结果
 */
export function validateToken() {
  return get('/ums/auth/validate', {}, {
    showLoading: false,
    showSuccessMessage: false,
    showErrorMessage: false // 验证失败不显示错误消息
  })
}